import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState, useRef, useEffect } from 'react';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import { getClonedChild } from '../../utils/componentHelpers.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { isBrowser } from '../../utils/dom.es.js';
import { useUpdateEffect } from '../../hooks/useUpdateEffect/useUpdateEffect.es.js';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';
import { Collapse, CollapseTitle, CollapseIcon, CollapseContentWrapper } from './styled.es.js';
import { getContentHeight } from './helpers.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var BaseCollapse = function BaseCollapse(_a) {
  var _b = _a,
      children = _b.children,
      isOpen = _b.isOpen,
      onOpen = _b.onOpen,
      onClose = _b.onClose,
      onToggle = _b.onToggle,
      _b$variant = _b.variant,
      variant = _b$variant === void 0 ? "default" : _b$variant,
      className = _b.className,
      _b$hasTitleClick = _b.hasTitleClick,
      hasTitleClick = _b$hasTitleClick === void 0 ? true : _b$hasTitleClick,
      props = __objRest(_b, ["children", "isOpen", "onOpen", "onClose", "onToggle", "variant", "className", "hasTitleClick"]);

  var _useState = useState(false),
      hasTitleHover = _useState[0],
      setHasTitleHover = _useState[1];

  var _useState2 = useState(0),
      contentHeight = _useState2[0],
      setContentHeight = _useState2[1];

  var _useState3 = useState({
    height: isBrowser ? window.innerHeight : 0,
    width: isBrowser ? window.innerWidth : 0
  }),
      dimensions = _useState3[0],
      setDimensions = _useState3[1];

  var contentRef = useRef(null);
  var childrenArray = children ? React.Children.toArray(children) : [];
  var title = getClonedChild(childrenArray, "Collapse.Title", __spreadValues({
    variant: variant,
    hasTitleHover: hasTitleHover,
    isOpen: isOpen
  }, props));
  var trigger = getClonedChild(childrenArray, "Collapse.Trigger", __spreadValues({
    onClick: onToggle
  }, props));
  var content = getClonedChild(childrenArray, "Collapse.Content", {
    ref: contentRef
  });
  useEffect(function () {
    var handleResize = function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      });
    };

    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useUpdateEffect(function () {
    isOpen ? onOpen == null ? void 0 : onOpen() : onClose == null ? void 0 : onClose();
  }, [isOpen, onClose, onOpen]);
  useEnhancedEffect(function () {
    setContentHeight(getContentHeight(contentRef));
  }, [content, dimensions]);

  var activateTitleHover = function activateTitleHover() {
    return setHasTitleHover(true);
  };

  var deactivateTitleHover = function deactivateTitleHover() {
    return setHasTitleHover(false);
  };

  return (
    /* @__PURE__ */
    React.createElement(Collapse, {
      hasTitleHover: hasTitleHover,
      className: className
    },
    /* @__PURE__ */
    React.createElement(CollapseTitle, __spreadValues({
      "aria-expanded": isOpen,
      onClick: hasTitleClick ? onToggle : void 0,
      onMouseEnter: hasTitleClick ? activateTitleHover : void 0,
      onMouseLeave: hasTitleClick ? deactivateTitleHover : void 0,
      hasTitleHover: hasTitleClick,
      isOpen: isOpen
    }, props), title, trigger ? trigger :
    /* @__PURE__ */
    React.createElement(CollapseIcon, {
      isOpen: isOpen,
      hasTitleHover: hasTitleHover,
      hasTitleClick: hasTitleClick,
      variant: variant,
      size: "md",
      onClick: !hasTitleClick ? onToggle : void 0
    })),
    /* @__PURE__ */
    React.createElement(CollapseContentWrapper, {
      isOpen: isOpen,
      contentHeight: contentHeight
    }, content))
  );
};

export { BaseCollapse };